var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('aHeader'),_c('div',{staticClass:"context"},[_c('router-view')],1),_c('aFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }